import React, { useEffect, useMemo, useState, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import API, { UPLOADS_URL } from '../api/axios';
import SEO from '../components/SEO';
import Reveal from '../components/ui/Reveal';
import Lightbox from '../components/ui/Lightbox';

const CDN = 'https://www.sawsindirapuram.com/wp-content/uploads';

const achievementFiles = [
  'IMG_9253.PNG', 'IMG_9254.PNG', 'IMG_9256.PNG',
  'IMG_9263.PNG', 'IMG_9268.PNG', 'IMG_9269.PNG', 'IMG_9272.PNG',
];

const SLIDES = [
  { img: '${process.env.PUBLIC_URL}/images/sliders/1-indirapuram-slider.jpg', alt: 'School Banner 1' },
  { img: '${process.env.PUBLIC_URL}/images/sliders/2-indirapuram-slider.jpg', alt: 'School Banner 2' },
  { img: '${process.env.PUBLIC_URL}/images/sliders/3-indirapuram-slider.jpg', alt: 'School Banner 3' },
  { img: '${process.env.PUBLIC_URL}/images/sliders/4-indirapuram-slider.jpg', alt: 'School Banner 4' },
];

const TICKER_DEFAULT = { text: '✨ Admissions Open for the 2027–28 Session', url: '' };

const resolveImg = (src) => {
  if (!src) return src;
  if (src.startsWith('/frontend/')) return src.replace('/frontend/', '/');
  if (src.startsWith('http') || src.startsWith('/')) return src;
  if (src.startsWith('awards/')) {
    return `https://sawsindirapuram.com/admin/public/uploads/${src}`;
  }
  return `${UPLOADS_URL}/${src}`;
};

const FACILITY_DATA = [
  { img: '${process.env.PUBLIC_URL}/images/facilities/Junior-Classroom.jpg', title: 'Junior Classrooms' },
  { img: '${process.env.PUBLIC_URL}/images/facilities/Computer-Lab.jpg', title: 'Computer Lab' },
  { img: '${process.env.PUBLIC_URL}/images/facilities/Science-Lab.jpg', title: 'Science Lab' },
  { img: '${process.env.PUBLIC_URL}/images/facilities/Music-Room.jpg', title: 'Music Room' },
  { img: '${process.env.PUBLIC_URL}/images/facilities/Library.jpg', title: 'Library' },
  { img: '${process.env.PUBLIC_URL}/images/facilities/Infrastructure.jpg', title: 'Infrastructure' },
];

const ACTIVITIES = [
  { img: '${process.env.PUBLIC_URL}/images/coactivities/Football.jpg', name: 'Football' },
  { img: '${process.env.PUBLIC_URL}/images/coactivities/Taekwondo.jpg', name: 'Taekwondo' },
  { img: '${process.env.PUBLIC_URL}/images/coactivities/Skating.jpg', name: 'Skating' },
  { img: '${process.env.PUBLIC_URL}/images/coactivities/Swimming-Pool.jpg', name: 'Swimming Pool' },
  { img: '${process.env.PUBLIC_URL}/images/coactivities/Chess.jpg', name: 'Chess' },
  { img: '${process.env.PUBLIC_URL}/images/coactivities/Cricket.jpg', name: 'Cricket' },
  { img: '${process.env.PUBLIC_URL}/images/coactivities/Badminton.jpg', name: 'Badminton' },
  { img: '${process.env.PUBLIC_URL}/images/coactivities/Basketball.jpg', name: 'Basketball' },
  { img: '${process.env.PUBLIC_URL}/images/coactivities/Art-Craft.jpg', name: 'Art & Craft' },
];

const HIGHLIGHTS = [
  { img: '${process.env.PUBLIC_URL}/images/highlights/cer.jpg', alt: 'Most Credible Group of Schools - Excellence in Education Award Singapore' },
  { img: '${process.env.PUBLIC_URL}/images/highlights/highlights-1.jpg', alt: 'School Event 1' },
  { img: '${process.env.PUBLIC_URL}/images/highlights/highlights-2.jpg', alt: 'School Event 2' },
  { img: '${process.env.PUBLIC_URL}/images/highlights/highlights-3.jpg', alt: 'School Event 3' },
  { img: '${process.env.PUBLIC_URL}/images/highlights/highlights-4.jpg', alt: 'School Event 4' },
  { img: '${process.env.PUBLIC_URL}/images/highlights/highlights-5.jpg', alt: 'School Event 5' },
  { img: '${process.env.PUBLIC_URL}/images/highlights/highlights-6.jpg', alt: 'School Event 6' },
  { img: '${process.env.PUBLIC_URL}/images/highlights/highlight-7.jpg', alt: 'School Event 7' },
  { img: '${process.env.PUBLIC_URL}/images/highlights/highlight-8.jpg', alt: 'School Event 8' },
  { img: '${process.env.PUBLIC_URL}/images/highlights/highlight-9.jpg', alt: 'School Event 9' },
  { img: '${process.env.PUBLIC_URL}/images/highlights/DSC_7098.jpg', alt: 'School Event 10' },
  { img: '${process.env.PUBLIC_URL}/images/highlights/DSC_7703.jpg', alt: 'School Event 11' },
  { img: '${process.env.PUBLIC_URL}/images/highlights/DSC_7788.jpg', alt: 'School Event 12' },
  { img: '${process.env.PUBLIC_URL}/images/highlights/DSC_8522.jpg', alt: 'School Event 13' },
];

const WHY_US_DEFAULT = [
  { icon: 'fa-book-open', title: 'ICSE Curriculum' },
  { icon: 'fa-chalkboard-user', title: 'Smart Classrooms' },
  { icon: 'fa-trophy', title: 'Sports Excellence' },
  { icon: 'fa-shield-halved', title: 'Safe Campus' },
  { icon: 'fa-user-graduate', title: 'Experienced Faculty' },
  { icon: 'fa-seedling', title: 'Holistic Development' },
];

const PROCESS_DEFAULT = [
  { title: 'Enquiry', icon: 'fa-message', desc: 'Connect with our admission team to begin the journey.' },
  { title: 'Visit', icon: 'fa-school', desc: 'Tour our campus and experience the learning environment.' },
  { title: 'Assessment', icon: 'fa-clipboard-check', desc: 'Informal interaction or written test as per grade.' },
  { title: 'Admission', icon: 'fa-circle-check', desc: 'Complete the formalities and secure your seat.' },
];

const Home = () => {
  const [activeSlide, setActiveSlide] = useState(0);
  const [notices, setNotices] = useState([]);
  const [events, setEvents] = useState([]);
  const [news, setNews] = useState([]);
  const [blogs, setBlogs] = useState([]);
  const [banners, setBanners] = useState([]);
  const [slides, setSlides] = useState([]);
  const [sectionData, setSectionData] = useState({});
  const [galleryAlbums, setGalleryAlbums] = useState([]);
  const [awards, setAwards] = useState([]);
  const [facilitiesState, setFacilitiesState] = useState([]);
  const [coCurricularState, setCoCurricularState] = useState([]);
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxItems, setLightboxItems] = useState([]);
  const [lightboxIndex, setLightboxIndex] = useState(0);
  const navigate = useNavigate();

  const ticker = { ...TICKER_DEFAULT, ...(sectionData.home_ticker || {}) };

  const openEnquiryPopup = (e) => {
    e.preventDefault();
    const btn = document.querySelector('.npfWidgetButton.npfWidget-19e823c49278038002c6e0e30ce39f61');
    if (btn) btn.click();
  };

  const highlightsRef = useRef(null);
  const achievementRef = useRef(null);
  const instagramRef = useRef(null);
  const awardsRef = useRef(null);
  const autoSlideRef = useRef(null);
  const highlightsItems = (sectionData.highlights?.items?.length ? sectionData.highlights.items : HIGHLIGHTS).map(i => ({ ...i, img: resolveImg(i.image || i.img) }));

  const aboutSec = sectionData.about && (sectionData.about.heading || sectionData.about.paragraphs) ? sectionData.about : null;
  const aboutKicker = aboutSec?.kicker || 'About St. Andrews';
  const aboutHeading = aboutSec?.heading || 'Welcome to the Best School in Indirapuram';
  const aboutImage = aboutSec?.image ? resolveImg(aboutSec.image) : '${process.env.PUBLIC_URL}/images/aboutus.jpeg';
  const aboutParagraphs = aboutSec?.paragraphs
    ? String(aboutSec.paragraphs).split('\n').map(p => p.trim()).filter(Boolean)
    : [
        "St. Andrews World School is dedicated to shaping tomorrow's leaders by providing an education that goes beyond academics. With seven branches across India, our mission is to foster curiosity, ignite a passion for learning, and empower students to reach their fullest potential.",
        "Backed by a team of dedicated educators, state-of-the-art facilities, and a focus on diversity and inclusion, we provide a well-rounded education that integrates academics, sports, and arts alongside extracurricular activities.",
      ];
  const aboutBtnText = aboutSec?.button_text || 'Read More';
  const aboutBtnLink = aboutSec?.button_link || '/about-us';
  const aboutVideos = aboutSec?.videos || [];
  const [aboutVideoIdx, setAboutVideoIdx] = useState(0);

  const whyUs = (sectionData.why_choose_us?.items?.length ? sectionData.why_choose_us.items : WHY_US_DEFAULT);
  const whyUsKicker = sectionData.why_choose_us?.kicker || 'Why Choose Us';
  const whyUsHeading = sectionData.why_choose_us?.heading || 'The St. Andrews Advantage';
  const whyUsDesc = sectionData.why_choose_us?.description || 'Every aspect of our school is designed to nurture confident, curious, and compassionate learners who are ready for the world.';

  const processItems = (sectionData.admission_process?.items?.length ? sectionData.admission_process.items : PROCESS_DEFAULT)
    .map((p, i) => ({ ...p, desc: p.desc || PROCESS_DEFAULT[i]?.desc || '' }));

  

  

  const achievements = sectionData.achievements?.items?.length
    ? sectionData.achievements.items.map(a => ({ img: resolveImg(a.image || a.img), alt: a.alt || 'Student Achievement' }))
    : achievementFiles.map(f => ({ img: `${process.env.PUBLIC_URL}/images/Student-achievement/${f}`, alt: 'Student Achievement' }));

  const facSec = sectionData.facilities?.items?.length ? sectionData.facilities : null;
  const facKicker = facSec?.kicker || 'Facilities';
  const facHeading = facSec?.heading || 'Our Facilities';
  const facDesc = facSec?.description || 'St. Andrews World School, Indirapuram is equipped with modern, thoughtfully designed facilities that support every aspect of a child\'s development.';
  const facilities = facilitiesState.length > 0 
    ? facilitiesState 
    : (sectionData.facilities?.items?.length ? sectionData.facilities.items : FACILITY_DATA).map(i => ({ ...i, img: resolveImg(i.image || i.img) }));

  const actSec = sectionData.activities?.items?.length ? sectionData.activities : null;
  const actKicker = actSec?.kicker || 'Activities';
  const actHeading = actSec?.heading || 'Co-Curricular Activities';
  const activities = coCurricularState.length > 0
    ? coCurricularState
    : (sectionData.activities?.items?.length ? sectionData.activities.items : ACTIVITIES).map(i => ({ ...i, img: resolveImg(i.image || i.img) }));

  const scrollHighlights = (dir) => {
    if (highlightsRef.current) {
      const cardWidth = highlightsRef.current.querySelector('[class*="shrink-0"]')?.offsetWidth || 300;
      highlightsRef.current.scrollBy({ left: dir * (cardWidth + 16), behavior: 'smooth' });
    }
  };
  const scrollAchievement = (dir) => {
    if (achievementRef.current) {
      const cardWidth = achievementRef.current.querySelector('[class*="shrink-0"]')?.offsetWidth || 300;
      achievementRef.current.scrollBy({ left: dir * (cardWidth + 16), behavior: 'smooth' });
    }
  };
  const scrollAwards = (dir) => {
    if (awardsRef.current) {
      const cardWidth = awardsRef.current.querySelector('[class*="shrink-0"]')?.offsetWidth || 300;
      awardsRef.current.scrollBy({ left: dir * (cardWidth + 16), behavior: 'smooth' });
    }
  };

  useEffect(() => {
    if (highlightsItems.length <= 1) return;
    autoSlideRef.current = setInterval(() => {
      if (highlightsRef.current) {
        const maxScroll = highlightsRef.current.scrollWidth - highlightsRef.current.clientWidth;
        const cardWidth = highlightsRef.current.querySelector('[class*="shrink-0"]')?.offsetWidth || 300;
        if (highlightsRef.current.scrollLeft >= maxScroll - 10) {
          highlightsRef.current.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          highlightsRef.current.scrollBy({ left: cardWidth + 16, behavior: 'smooth' });
        }
      }
    }, 3500);
    return () => clearInterval(autoSlideRef.current);
  }, [highlightsItems.length]);

  useEffect(() => {
    const el = achievementRef.current;
    if (!el) return;
    const interval = setInterval(() => {
      const maxScroll = el.scrollWidth - el.clientWidth;
      const cardWidth = el.querySelector('[class*="shrink-0"]')?.offsetWidth || 300;
      if (el.scrollLeft >= maxScroll - 10) {
        el.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        el.scrollBy({ left: cardWidth + 16, behavior: 'smooth' });
      }
    }, 3500);
    return () => clearInterval(interval);
  }, [achievements.length]);

  useEffect(() => {
    const el = awardsRef.current;
    if (!el) return;
    const interval = setInterval(() => {
      const maxScroll = el.scrollWidth - el.clientWidth;
      const cardWidth = el.querySelector('[class*="shrink-0"]')?.offsetWidth || 300;
      if (el.scrollLeft >= maxScroll - 10) {
        el.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        el.scrollBy({ left: cardWidth + 16, behavior: 'smooth' });
      }
    }, 3500);
    return () => clearInterval(interval);
  }, [awards.length]);

  useEffect(() => {
    if (aboutVideos.length <= 1) return;
    const interval = setInterval(() => {
      setAboutVideoIdx(prev => (prev + 1) % aboutVideos.length);
    }, 12000);
    return () => clearInterval(interval);
  }, [aboutVideos.length]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [noticeRes, eventsRes, newsRes, blogRes, bannerRes, sectionRes, awardsRes, facilitiesRes, activitiesRes] = await Promise.all([
          API.get('/notices/latest'),
          API.get('/events/active'),
          API.get('/notices/news'),
          API.get('/blogs/latest'),
          API.get('/banners/active'),
          API.get('/home-sections'),
          API.get('/awards/public').catch(() => ({ data: { data: [] } })),
          API.get('/facilities/public').catch(() => ({ data: { data: [] } })),
          API.get('/co-curricular-activities/public').catch(() => ({ data: { data: [] } })),
        ]);
        if (noticeRes.data.data && noticeRes.data.data.length) setNotices(noticeRes.data.data);
        if (eventsRes.data.data && eventsRes.data.data.length) setEvents(eventsRes.data.data);
        if (newsRes.data.data && newsRes.data.data.length) setNews(newsRes.data.data);
        if (blogRes.data.data && blogRes.data.data.length) setBlogs(blogRes.data.data);
        if (awardsRes.data?.data && awardsRes.data.data.length) setAwards(awardsRes.data.data);
        if (facilitiesRes?.data?.data && facilitiesRes.data.data.length) {
          setFacilitiesState(facilitiesRes.data.data.map(f => ({
            img: resolveImg(f.image),
            title: f.title
          })));
        }
        if (activitiesRes?.data?.data && activitiesRes.data.data.length) {
          setCoCurricularState(activitiesRes.data.data.map(a => ({
            img: resolveImg(a.image),
            name: a.title,
            slug: a.slug,
          })));
        }
        if (bannerRes.data.data && bannerRes.data.data.length) {
          const mapped = bannerRes.data.data.map(b => ({
            img: resolveImg(b.image),
            alt: b.title || 'Banner',
            link: b.link,
            btn_text: b.btn_text,
          }));
          setSlides(mapped);
        } else {
          setSlides(SLIDES);
        }
        if (sectionRes.data.data) setSectionData(sectionRes.data.data);
        try {
          const galleryRes = await API.get('/galleries/public?limit=8');
          if (galleryRes.data.data && galleryRes.data.data.length) setGalleryAlbums(galleryRes.data.data);
        } catch (gErr) { console.error('Gallery fetch error:', gErr); }
      } catch (err) { console.error(err); }
    };
    fetchData();
  }, []);

  useEffect(() => {
    if (slides.length <= 1) return;
    const interval = setInterval(() => setActiveSlide(prev => (prev + 1) % slides.length), 4000);
    return () => clearInterval(interval);
  }, [slides.length]);

  useEffect(() => {
    if (!instagramRef.current) return;
    const host = instagramRef.current;
    host.innerHTML = '<div class="sk-instagram-feed" data-embed-id="25716970"></div>';
    const url = 'https://widgets.sociablekit.com/instagram-feed/widget.js';
    if (!document.querySelector(`script[src="${url}"]`)) {
      const script = document.createElement('script');
      script.src = url;
      script.defer = true;
      document.body.appendChild(script);
    }
    const hideBranding = () => {
      document.querySelectorAll('.tutorial_link').forEach((el) => el.remove());
    };
    const observer = new MutationObserver(hideBranding);
    observer.observe(host, { childList: true, subtree: true });
    hideBranding();
    const t = setTimeout(hideBranding, 5000);
    return () => { observer.disconnect(); clearTimeout(t); };
  }, []);

  const prevSlide = () => setActiveSlide(prev => (prev - 1 + slides.length) % slides.length);
  const nextSlide = () => setActiveSlide(prev => (prev + 1) % slides.length);

  const openLightbox = (items, index = 0) => {
    const safe = Array.isArray(items) ? items.filter(Boolean) : [];
    if (safe.length === 0) return;
    setLightboxItems(safe);
    setLightboxIndex(Math.max(0, Math.min(index, safe.length - 1)));
    setLightboxOpen(true);
  };

  const noticesList = [...notices, ...news].filter(Boolean).slice(0, 4);
  const eventsList = events.slice(0, 4);
  const fmtDate = (str) => {
    if (!str) return '';
    const d = new Date(str);
    return d.toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' });
  };

  return (
    <>
      <SEO
        slug="home"
        title="Home"
        description="St. Andrews World School, Indirapuram - premium ICSE education with modern learning, holistic development, and world-class facilities. Admissions open for 2027-28."
        keywords="ICSE school in Indirapuram, best school in Indirapuram, admissions 2027-28, St. Andrews World School, ICSE curriculum, smart classrooms, sports, activities"
        schema={[
          {
            '@context': 'https://schema.org',
            '@type': 'School',
            name: 'St. Andrews World School',
            url: (process.env.REACT_APP_SITE_URL || 'https://sawsindirapuram.com'),
            address: { '@type': 'PostalAddress', addressLocality: 'Indirapuram', addressRegion: 'Haryana', addressCountry: 'IN' },
          },
        ]}
      />

      {/* ============ H1 (visually hidden, accessible) ============ */}
      <h1 className="sr-only">St. Andrews World School, Indirapuram — Best ICSE School in Ghaziabad</h1>

      {/* ============ HERO ============ */}
      <section className="relative bg-midnight overflow-hidden">
        <div className="relative h-[240px] sm:h-[350px] md:h-[420px] lg:h-[540px] xl:h-[600px]">
          {slides.map((slide, i) => (
            <div
              key={i}
              className={`absolute inset-0 transition-opacity duration-1000 ${i === activeSlide ? 'opacity-100 z-0' : 'opacity-0 z-0'}`}
              aria-hidden={i !== activeSlide}
            >
              <img src={slide.img} alt={slide.alt} className="w-full h-full object-fill md:object-cover" loading={i === activeSlide ? 'eager' : 'lazy'} />
            </div>
          ))}

          {/* Overlay */}
          <div className="absolute inset-0 bg-gradient-to-t from-[#0d1b3e]/60 via-transparent to-transparent z-[1]"></div>

          {/* Slide dots */}
          {slides.length > 1 && (
            <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-[3] flex gap-2.5">
              {slides.map((_, i) => (
                <button
                  key={i}
                  aria-label={`Go to slide ${i + 1}`}
                  className={`rounded-full border-none cursor-pointer transition-all duration-500 ${
                    i === activeSlide ? 'bg-[#D4A73E] w-8 h-2.5' : 'bg-white/40 w-2.5 h-2.5 hover:bg-white/70'
                  }`}
                  onClick={() => setActiveSlide(i)}
                />
              ))}
            </div>
          )}

          {/* Arrows */}
          {slides.length > 1 && (
            <>
              <button onClick={prevSlide} aria-label="Previous slide" className="btn-nav bg-white/10 backdrop-blur border border-white/20 text-white hover:bg-white/25 absolute left-4 top-1/2 -translate-y-1/2 z-[3]"><i className="fas fa-chevron-left text-sm"></i></button>
              <button onClick={nextSlide} aria-label="Next slide" className="btn-nav bg-white/10 backdrop-blur border border-white/20 text-white hover:bg-white/25 absolute right-4 top-1/2 -translate-y-1/2 z-[3]"><i className="fas fa-chevron-right text-sm"></i></button>
            </>
          )}
        </div>
      </section>

      {/* ============ ADMISSIONS TICKER ============ */}
      <section className="bg-[#1B3160] border-b border-white/10 py-3.5 relative overflow-hidden">
        <div className="container">
          <a
            href={ticker.url || '#'}
            onClick={ticker.url ? undefined : openEnquiryPopup}
            className="text-white/90 hover:text-white text-[14px] md:text-[16px] font-medium no-underline tracking-wide transition-colors cursor-pointer flex items-center justify-center gap-2 text-center"
          >
            <span>{ticker.text}</span>
          </a>
        </div>
      </section>

      {/* ============ ABOUT ============ */}
      <Reveal>
        <section className="py-14 md:py-20 bg-white relative overflow-hidden">
          <div className="absolute top-24 -right-24 w-96 h-96 rounded-full bg-[#1B3160]/5 blur-3xl"></div>
          <div className="container relative overflow-hidden">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 md:gap-16 items-center">
              <div className="relative max-lg:order-2">
                <div className="absolute -inset-1 bg-gradient-to-br from-[#D4A73E]/30 to-[#1B3160]/20 rounded-3xl blur-lg opacity-60"></div>
                {aboutVideos.length ? (
                  <div className="relative rounded-2xl overflow-hidden shadow-2xl">
                    <div className="relative" style={{ paddingBottom: '56.25%', height: 0 }}>
                      {aboutVideos.map((v, i) => (
                        <iframe
                          key={v.video_id}
                          src={`https://www.youtube.com/embed/${v.video_id}${i === aboutVideoIdx ? '?autoplay=1&mute=1' : ''}`}
                          title={v.title || 'School Video'}
                          className="absolute inset-0 w-full h-full transition-opacity duration-500"
                          style={{ border: 'none', opacity: i === aboutVideoIdx ? 1 : 0, zIndex: i === aboutVideoIdx ? 1 : 0 }}
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                          allowFullScreen
                          loading="lazy"
                        />
                      ))}
                    </div>
                  </div>
                ) : (
                  <div className="relative rounded-2xl overflow-hidden shadow-2xl">
                    <img src={aboutImage} alt="About St. Andrews World School" className="w-full h-auto object-cover" loading="lazy" />
                  </div>
                )}
              </div>
              <div className="max-lg:order-1">
                <div className="kicker">{aboutKicker}</div>
                <h2 className="text-[28px] md:text-[38px] font-bold text-primary mt-2 mb-4 leading-tight">{aboutHeading}</h2>
                <div className="w-14 h-[3px] bg-[#D4A73E] rounded-full mb-7"></div>
                {aboutParagraphs.map((p, i) => (
                  <p key={i} className="text-body text-[16px] md:text-[17px] leading-relaxed mb-5" style={{ WebkitHyphens: 'none', msHyphens: 'none', hyphens: 'none', textAlign: 'left' }}>{p}</p>
                ))}
                <Link to={aboutBtnLink} className="btn-navy">{aboutBtnText} <i className="fas fa-arrow-right text-[11px]"></i></Link>
              </div>
            </div>
          </div>
        </section>
      </Reveal>

      {/* ============ HIGHLIGHTS ============ */}
      <Reveal>
        <section className="py-14 md:py-20 bg-[#1B3260] relative overflow-hidden">
          <div className="absolute inset-0 opacity-[0.04]" style={{ backgroundImage: 'radial-gradient(circle at 1px 1px, #fff 1px, transparent 0)', backgroundSize: '24px 24px' }} />
          <div className="container relative overflow-hidden">
            <div className="text-center mb-12">
              <div className="kicker text-[#F3D27E]">{sectionData.highlights?.kicker || 'Highlights'}</div>
              <h2 className="text-[28px] md:text-[38px] font-bold text-white mt-2">{sectionData.highlights?.heading || 'Achievements & Moments'}</h2>
              <div className="w-14 h-[3px] bg-[#D4A73E] rounded-full mx-auto mt-4"></div>
            </div>
            <div className="relative">
              <div ref={highlightsRef} className="flex gap-4 md:gap-6 overflow-x-auto scroll-smooth snap-x snap-mandatory pb-2 hide-scrollbar justify-start">
                {highlightsItems.map((item, idx) => (
                  <button
                    key={item.img}
                    type="button"
                    className="snap-start shrink-0 w-[75vw] sm:w-[300px] rounded-xl overflow-hidden border border-white/10 bg-white shadow-sm hover:shadow-2xl transition-all group"
                    onClick={() => openLightbox(highlightsItems, idx)}
                  >
                    <div className="relative h-[320px] md:h-[380px] overflow-hidden">
                      <img
                        src={item.img}
                        alt={item.alt}
                        className="w-full h-full  transition-transform duration-700 group-hover:scale-105"
                        loading="lazy"
                      />
                      <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors"></div>
                    </div>
                  </button>
                ))}
              </div>
              {highlightsItems.length > 1 && (
                <>
                  <button onClick={() => scrollHighlights(-1)} aria-label="Previous" className="btn-nav absolute left-0 top-1/2 -translate-y-1/2 -translate-x-1.5 sm:-translate-x-3 bg-white text-[#1B3260] shadow-lg hover:bg-gray-50 z-10"><i className="fas fa-chevron-left text-sm"></i></button>
                  <button onClick={() => scrollHighlights(1)} aria-label="Next" className="btn-nav absolute right-0 top-1/2 -translate-y-1/2 translate-x-1.5 sm:translate-x-3 bg-white text-[#1B3260] shadow-lg hover:bg-gray-50 z-10"><i className="fas fa-chevron-right text-sm"></i></button>
                </>
              )}
            </div>
          </div>
        </section>
      </Reveal>

      {/* ============ STUDENT ACHIEVEMENTS ============ */}
      <Reveal>
        <section className="py-14 md:py-20 bg-white">
          <div className="container">
            <div className="text-center mb-12">
              <div className="kicker">Student Achievement</div>
              <h2 className="text-[26px] md:text-[32px] font-bold text-primary mt-2">Our Achievers</h2>
              <div className="w-14 h-[3px] bg-[#D4A73E] rounded-full mx-auto mt-4"></div>
            </div>
            <div className="relative">
              <div ref={achievementRef} className="flex gap-4 md:gap-6 overflow-x-auto scroll-smooth snap-x snap-mandatory pb-2 hide-scrollbar justify-start">
                {achievements.map((file, idx) => (
                  <Reveal key={file.img || file.image} delayMs={idx * 50} className="shrink-0 snap-start w-[75vw] sm:w-[300px]">
                    <button
                      type="button"
                      onClick={() => openLightbox(achievements, idx)}
                      className="group w-full rounded-xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 border border-gray-100 bg-white"
                    >
                      <div className="relative overflow-hidden" style={{ aspectRatio: '4 / 5' }}>
                        <img
                          src={file.img}
                          alt={file.alt || 'Student Achievement'}
                          className="w-full h-full  transition-transform duration-700 group-hover:scale-105"
                          loading="lazy"
                        />
                        <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors duration-300 flex items-center justify-center">
                          <div className="w-12 h-12 rounded-full bg-white/90 text-primary flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all duration-300 transform translate-y-4 group-hover:translate-y-0">
                            <i className="fas fa-expand text-sm" />
                          </div>
                        </div>
                      </div>
                    </button>
                  </Reveal>
                ))}
              </div>
              {achievements.length > 1 && (
                <>
                  <button onClick={() => scrollAchievement(-1)} aria-label="Previous" className="btn-nav absolute left-0 top-1/2 -translate-y-1/2 -translate-x-1.5 sm:-translate-x-3 bg-white shadow-lg border border-gray-100 text-[#1B3160] hover:bg-gray-50 z-10"><i className="fas fa-chevron-left text-sm"></i></button>
                  <button onClick={() => scrollAchievement(1)} aria-label="Next" className="btn-nav absolute right-0 top-1/2 -translate-y-1/2 translate-x-1.5 sm:translate-x-3 bg-white shadow-lg border border-gray-100 text-[#1B3160] hover:bg-gray-50 z-10"><i className="fas fa-chevron-right text-sm"></i></button>
                </>
              )}
            </div>
          </div>
        </section>
      </Reveal>

      {/* ============ AWARDS ============ */}
      <Reveal>
        <section className="py-14 md:py-20 bg-[#1B3260] relative overflow-hidden">
          <div className="absolute inset-0 opacity-[0.04]" style={{ backgroundImage: 'radial-gradient(circle at 1px 1px, #fff 1px, transparent 0)', backgroundSize: '24px 24px' }} />
          <div className="container relative">
            <div className="text-center mb-12">
              <div className="kicker text-[#F3D27E]">Awards</div>
              <h2 className="text-[26px] md:text-[32px] font-bold text-white mt-2">Our Awards & Recognition</h2>
              <div className="w-14 h-[3px] bg-[#D4A73E] rounded-full mx-auto mt-4"></div>
            </div>
            <div className="relative">
              <div ref={awardsRef} className="flex gap-4 md:gap-6 overflow-x-auto scroll-smooth snap-x snap-mandatory pb-2 hide-scrollbar justify-start">
                {(awards.length > 0 ? awards : []).map((award, idx) => (
                  <div key={award.id || idx} className="group snap-start shrink-0 w-[80vw] sm:w-1/2 lg:w-1/3 rounded-xl overflow-hidden border border-white/10 bg-white shadow-sm hover:shadow-2xl transition-all duration-500">
                    <div
                      className="relative overflow-hidden h-[280px] md:h-[280px] flex items-center justify-center p-3 cursor-pointer"
                      onClick={() => openLightbox(awards.map(a => ({ img: resolveImg(a.image), alt: a.name || 'Award' })), idx)}
                    >
                      <img
                        src={resolveImg(award.image)}
                        alt={award.name || 'Award'}
                        className="w-auto h-auto max-w-full max-h-full border-2 border-gray-200 group-hover:scale-105 transition-transform duration-500 object-contain"
                        loading="lazy"
                        onError={(e) => {
                          if (!e.currentTarget.dataset.fallbackTried && award.image) {
                            e.currentTarget.dataset.fallbackTried = '1';
                            const cur = e.currentTarget.src;
                            if (cur.includes('/admin/uploads/')) {
                              e.currentTarget.src = cur.replace('/admin/uploads/', '/admin/public/uploads/');
                            } else if (cur.includes('/admin/public/uploads/')) {
                              e.currentTarget.src = cur.replace('/admin/public/uploads/', '/admin/uploads/');
                            }
                          }
                        }}
                      />
                      <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors duration-300 flex items-center justify-center">
                        <div className="w-10 h-10 rounded-full bg-white/90 text-primary flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all duration-300 shadow-md">
                          <i className="fas fa-search-plus text-sm"></i>
                        </div>
                      </div>
                      {(award.name || award.awarded_by || award.year) && (
                        <div className="absolute bottom-0 inset-x-0 bg-gradient-to-t from-[#1B3260]/95 via-[#1B3260]/70 to-transparent p-3 pt-6 text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                          {award.name && <h4 className="font-semibold text-sm truncate">{award.name}</h4>}
                          <div className="flex items-center justify-between text-[11px] text-white/90 mt-0.5">
                            {award.awarded_by && <span className="truncate">{award.awarded_by}</span>}
                            {award.year && <span className="font-bold text-[#F3D27E] ml-auto">{award.year}</span>}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </div>
              <button onClick={() => scrollAwards(-1)} aria-label="Previous" className="btn-nav absolute left-0 top-1/2 -translate-y-1/2 -translate-x-1.5 sm:-translate-x-3 bg-white text-[#1B3260] shadow-lg hover:bg-gray-50 z-10"><i className="fas fa-chevron-left text-sm"></i></button>
              <button onClick={() => scrollAwards(1)} aria-label="Next" className="btn-nav absolute right-0 top-1/2 -translate-y-1/2 translate-x-1.5 sm:translate-x-3 bg-white text-[#1B3260] shadow-lg hover:bg-gray-50 z-10"><i className="fas fa-chevron-right text-sm"></i></button>
            </div>
          </div>
        </section>
      </Reveal>

      {/* ============ FACILITIES ============ */}
      <Reveal>
        <section className="py-14 md:py-20 bg-white">
          <div className="container">
            <div className="text-center mb-12">
              <div className="kicker">{facKicker}</div>
              <h2 className="text-[26px] md:text-[32px] font-bold text-primary mt-2">{facHeading}</h2>
              <div className="w-14 h-[3px] bg-[#D4A73E] rounded-full mx-auto mt-4"></div>
              <p className="text-body text-[15px] md:text-base max-w-3xl mx-auto mt-4">{facDesc}</p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
              {facilities.map((f, i) => (
                <Reveal key={f.title} delayMs={i * 70}>
                  <button type="button" className="relative group w-full text-left" onClick={() => openLightbox(facilities.map(x => ({ img: x.img, alt: x.title })), i)}>
                    <div className="relative overflow-hidden rounded-2xl shadow-md border border-gray-100">
                      <div className="h-[240px] overflow-hidden">
                        <img src={f.img} alt={f.title} className="w-full h-full object-cover transition-all duration-700 group-hover:scale-110" loading="lazy" />
                      </div>
                      <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/15 to-transparent"></div>
                      <div className="absolute bottom-0 left-0 right-0 p-5 flex items-center justify-between">
                        <h3 className="text-white text-lg font-semibold">{f.title}</h3>
                        <div className="w-9 h-9 rounded-full bg-[#D4A73E] text-[#0d1b3e] flex items-center justify-center opacity-0 group-hover:opacity-100 translate-x-3 group-hover:translate-x-0 transition-all duration-300"><i className="fas fa-arrow-right text-xs"></i></div>
                      </div>
                    </div>
                  </button>
                </Reveal>
              ))}
            </div>
          </div>
        </section>
      </Reveal>

      {/* ============ ACTIVITIES ============ */}
      <Reveal>
        <section className="py-14 md:py-20 bg-[#1B3160] relative overflow-hidden">
          <div className="absolute inset-0 opacity-[0.04]" style={{ backgroundImage: 'radial-gradient(circle at 1px 1px, #fff 1px, transparent 0)', backgroundSize: '24px 24px' }} />
          <div className="container relative">
            <div className="text-center mb-12">
              <div className="kicker text-[#F3D27E]">{actKicker}</div>
              <h2 className="text-[26px] md:text-[32px] font-bold text-white mt-2">{actHeading}</h2>
              <div className="w-14 h-[3px] bg-[#D4A73E] rounded-full mx-auto mt-4"></div>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
              {activities.map((activity, i) => (
                <Reveal key={activity.name} delayMs={i * 70}>
                  <button type="button" className="relative group w-full text-left" onClick={() => openLightbox(activities.map(x => ({ img: x.img, alt: x.name })), i)}>
                    <div className="relative overflow-hidden rounded-2xl shadow-md border border-white/10">
                      <div className="h-[240px] overflow-hidden">
                        <img src={activity.img} alt={activity.name} className="w-full h-full object-cover transition-all duration-700 group-hover:scale-110" loading="lazy" />
                      </div>
                      <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/15 to-transparent"></div>
                      <div className="absolute bottom-0 left-0 right-0 p-5 flex items-center justify-between gap-3">
                        <h3 className="text-white text-lg font-semibold">{activity.name}</h3>
                        <div className="w-9 h-9 rounded-full bg-[#D4A73E] text-[#0d1b3e] flex items-center justify-center opacity-0 group-hover:opacity-100 translate-x-3 group-hover:translate-x-0 transition-all duration-300 shrink-0"><i className="fas fa-arrow-right text-xs"></i></div>
                      </div>
                    </div>
                  </button>
                </Reveal>
              ))}
            </div>
          </div>
        </section>
      </Reveal>

      {/* ============ ADMISSION PROCESS ============ */}
      <Reveal>
        <section className="py-14 md:py-20 bg-white relative overflow-hidden">
          <div className="container">
            <div className="text-center mb-12">
              <div className="kicker">Easy Admission</div>
              <h2 className="text-[28px] md:text-[38px] font-bold text-primary mt-2">Admission Process</h2>
              <div className="w-14 h-[3px] bg-[#D4A73E] rounded-full mx-auto mt-4"></div>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
              {processItems.map((step, i) => (
                <Reveal key={step.title} delayMs={i * 100}>
                  <div className="relative h-full">
                    {i < processItems.length - 1 && (
                      <div className="hidden lg:block absolute top-10 left-[calc(50%+40px)] w-[calc(100%-80px)] h-0.5 border-t-2 border-dashed border-[#D4A73E]/40"></div>
                    )}
                    <div className="group relative bg-white rounded-2xl border border-gray-100 p-7 text-center shadow-sm hover:shadow-xl hover:-translate-y-1.5 transition-all duration-400 h-full flex flex-col items-center">
                      <div className="relative mb-5">
                        <div className="w-20 h-20 rounded-2xl bg-gradient-to-br from-[#1B3160] to-[#2a4a94] flex items-center justify-center text-[#F3D27E] text-2xl shadow-lg shadow-[#1B3160]/20 group-hover:scale-110 transition-transform duration-300">
                          <i className={`fas ${step.icon || 'fa-circle-check'}`}></i>
                        </div>
                        <div className="absolute -top-2 -right-2 w-7 h-7 rounded-full bg-[#D4A73E] text-white text-[12px] font-bold flex items-center justify-center shadow-md">{i + 1}</div>
                      </div>
                      <h3 className="text-primary text-[17px] font-bold mb-2">{step.title}</h3>
                      <p className="text-body text-[13.5px] leading-relaxed mb-0">{step.desc}</p>
                    </div>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </section>
      </Reveal>

      {/* ============ CTA BANNER ============ */}
      <section className="relative overflow-hidden bg-[#1B3160]">
        <div className="absolute inset-0 pointer-events-none">
          <div className="absolute inset-0 opacity-[0.03] bg-[radial-gradient(#ffffff_1px,transparent_1px)] [background-size:32px_32px]"></div>
        </div>
        <div className="container relative py-16 md:py-20 text-center">
          <Reveal>
            <h2 className="text-[30px] md:text-[42px] font-extrabold text-white leading-tight">Begin Your Child's Journey<br className="hidden md:block" /> with St. Andrews</h2>
            <p className="text-white/70 max-w-xl mx-auto mt-4 text-[15px] md:text-base" style={{ textAlign: 'center' }}>Admissions open for the 2027–28 Session. Join a community that believes in Education for All and excellence for each.</p>
            <div className="flex flex-wrap justify-center gap-4 mt-8">
              <Link to="/admission" className="btn-gold">Apply Now <i className="fas fa-arrow-right text-xs"></i></Link>
              <Link to="/contact-us" className="btn-outline"><i className="fas fa-phone"></i> Contact Admission Office</Link>
            </div>
          </Reveal>
        </div>
      </section>

      {/* ============ INSTAGRAM FEED ============ */}
      <section className="relative overflow-hidden bg-white py-16 md:py-20">
        <div className="absolute top-24 -right-24 w-96 h-96 rounded-full bg-[#1B3160]/5 blur-3xl" aria-hidden />
        <div className="absolute bottom-0 -left-32 w-80 h-80 rounded-full bg-[#D4A73E]/10 blur-3xl" aria-hidden />
        <div className="container relative">
          <div className="text-center mb-12">
            <div className="kicker">Stay Connected</div>
            <h2 className="text-[28px] md:text-[38px] font-bold text-primary mt-2">✨ Admission Open Session 2027-28</h2>
            <div className="w-14 h-[3px] bg-[#D4A73E] rounded-full mx-auto mt-4"></div>
          </div>
          <div ref={instagramRef} />
        </div>
      </section>

      <Lightbox
        open={lightboxOpen}
        items={lightboxItems}
        initialIndex={lightboxIndex}
        onClose={() => setLightboxOpen(false)}
      />
    </>
  );
};

export default Home;